import React from "react"
import { User } from "../../ZeefTypes"

interface MessageProps {
  message: {
    id: string
    type: "user" | "received" | "error"
    content: string
    timestamp: string
    sender?: User | null
    isHistorical?: boolean
    isBroadcast?: boolean
  }
  currentUser: User | null
  index: number
  threadDepth?: number
  onReplyClick?: (message: any) => void
  identifier?: string
  showIdentifier?: boolean
}

const Message: React.FC<MessageProps> = ({
  message,
  currentUser,
  index,
  threadDepth = 0,
  onReplyClick,
  identifier,
  showIdentifier,
}) => {
  const isUser = message.type === "user"
  const isError = message.type === "error"
  const isReceived = message.type === "received"
  const isHistorical = message.isHistorical || false
  const isBroadcast = message.isBroadcast || false
  const isThreadReply = threadDepth > 0

  const timestamp = new Date(message.timestamp).toLocaleTimeString()
  const username = isUser
    ? currentUser?.username || "You"
    : isReceived && message.sender
      ? message.sender.username
      : isError
        ? "System"
        : "Unknown"

  const renderMessageContent = () => {
    return message.content
  }

  const handleReplyClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (onReplyClick) {
      onReplyClick(message)
    }
  }

  const threadIndentStyle = isThreadReply
    ? {
        marginLeft: `${threadDepth * 2}rem`,
      }
    : {}

  return (
    <div
      key={message.id || index}
      className={`zeef-message irc-style ${isUser ? "user-message" : ""} ${isReceived ? "received-message" : ""} ${isError ? "error-message" : ""} ${isHistorical ? "historical-message" : ""} ${isBroadcast ? "broadcast-message" : ""} ${isThreadReply ? "thread-reply" : ""} ${showIdentifier ? "has-identifier" : ""}`}
      style={threadIndentStyle}
      data-thread-depth={threadDepth}
    >
      {showIdentifier && identifier && <span className="message-identifier">{identifier}</span>}
      <span className="message-timestamp">{timestamp}</span>
      <span
        className={`message-username ${!isError ? "clickable-username" : ""}`}
        onClick={!isError ? handleReplyClick : undefined}
        title={!isError ? "Click to reply to this message" : undefined}
      >
        {username}
        {isBroadcast && <span className="broadcast-indicator">BROADCAST</span>}
      </span>
      <span className="message-content">{renderMessageContent()}</span>
    </div>
  )
}

export default Message
